import React from 'react'
import { renderWithRoot } from '../common/react-root-helper'
import { getState, subscribe } from '../store'
import appActions from '../actions/app'
import { getFiles, postFile } from './actions'
import App from '../common/app'
import Files from './components/index'
let unsubscribe = function () {}

function render () {
  renderWithRoot(
    <App active="file" {...getState()} {...appActions}>
      <Files {...getState().files} postFile={postFile} />
    </App>,
    document.querySelector('#app')
  )
}

export function enter (context, next) {
  unsubscribe = subscribe(render)
  getFiles()
  render()
}

export function exit (context, next) {
  unsubscribe()
  next()
}
